import type { components } from "../generated/api-types.js";
import {
  type BodyTransformOptions,
  processBodyMd,
} from "./body-transformer.js";

export type CommentTransformOptions = BodyTransformOptions;

export function transformComment(
  comment: components["schemas"]["Comment"],
  options: CommentTransformOptions = {},
) {
  const bodyMd = processBodyMd(comment.body_md, options);

  return {
    id: comment.id,
    post_number: comment.post_number,
    url: comment.url,
    ...(bodyMd !== undefined && { body_md: bodyMd }),
    created_at: comment.created_at,
    updated_at: comment.updated_at,
    created_by: comment.created_by,
    stats: {
      stargazers_count: comment.stargazers_count,
      star: comment.star,
    },
    stargazers: comment.stargazers,
  };
}

export type TransformedComment = ReturnType<typeof transformComment>;
